import CountryLanding from "@/components/country/CountryLanding";
import { COLOMBIA } from "@/data/countryPages";

export default function EOSColombia() {
  return <CountryLanding country={COLOMBIA} />;
}
